import { classes } from 'html-classes';

import { company } from '~/company/Company';
import { ProductCardSkeletonProps } from '~/components/ProductCardV3/skeletons/types';

import styles from './ProductCardSkeletonXS.module.scss';

/**
 * ProductCardSkeletonXS - Loading skeleton for ProductCardXS
 * Card: mobile 72×92px, web 140×172px
 * Image: mobile 72×64px, web 140×128px
 * Minimal skeleton with only image and name
 */
const ProductCardSkeletonXS = ({ className }: ProductCardSkeletonProps) => {
  return (
    <div
      className={classes([styles.skeleton, className])}
      data-company={company.name}
    >
      {/* Image skeleton */}
      <div className={styles.imageWrapper} />

      {/* Info section skeleton */}
      <div className={styles.infoWrapper}>
        {/* Name lines (2 lines) */}
        <div className={styles.nameSection}>
          <div className={styles.nameLine} />
          <div className={classes([styles.nameLine, styles.nameLine_short])} />
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeletonXS;
